import { LoggerStore } from '../core/stores/logger.store';
import { rootContainer } from '../ioc';

const logger = rootContainer.get(LoggerStore);

let lastError = '';

// NOTE: in dev, arguments will have dummy values if webpack config is set to `devtool: 'eval-source-map'`.
// If you need to test this, switch to `devtool: 'source-map'` instead.

window.onerror = (message, source, lineno, colno, error) => {
    let val = message as string;
    if (error && error.stack) {
        val += `\n${error.stack}`;
    }

    if (val !== lastError) {
        lastError = val;
        logger.error(val);
    }
};
